import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "breakpoint", "category", "imgSrc", "onClick", "children", "disableImageAlt"];
var __jsx = React.createElement;
import React from 'react';
import styled from 'styled-components';
import { layout } from 'styled-system';
import Card from 'shared/components/card';
import Imgix from 'shared/components/imgix';
export default function CategoryTile(_ref) {
  var label = _ref.label,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? "960" : _ref$breakpoint,
    category = _ref.category,
    imgSrc = _ref.imgSrc,
    onClick = _ref.onClick,
    children = _ref.children,
    _ref$disableImageAlt = _ref.disableImageAlt,
    disableImageAlt = _ref$disableImageAlt === void 0 ? false : _ref$disableImageAlt,
    props = _objectWithoutProperties(_ref, _excluded);
  var computedLabel = label || (category === null || category === void 0 ? void 0 : category.label);
  return __jsx(StyledCard, _extends({
    breakpoint: breakpoint,
    alwaysShowShadow: true,
    onClick: onClick
  }, props), children, __jsx(CardHeader, null, __jsx(Title, {
    breakpoint: breakpoint
  }, computedLabel)), __jsx(ImageContainer, null, __jsx(Image, {
    src: imgSrc,
    htmlAttributes: {
      alt: disableImageAlt ? '' : computedLabel
    }
  })));
}
export var StyledCard = styled(Card).withConfig({
  displayName: "category-tile__StyledCard",
  componentId: "sc-134v6e-0"
})(["background:#fff;border-radius:", ";height:100%;justify-content:flex-start;padding:15px;width:100%;", " @media only screen and (min-width:992px){&:hover{box-shadow:0px 5px 14px rgba(0,0,0,0.25);}&:focus{box-shadow:0px 5px 14px rgba(0,0,0,0.25);outline-color:transparent;outline-width:2px;}}@media screen and (min-width:", "px){padding:20px 25px;}"], function (_ref2) {
  var _theme$customized$rad, _theme$customized;
  var theme = _ref2.theme;
  return (_theme$customized$rad = theme === null || theme === void 0 || (_theme$customized = theme.customized) === null || _theme$customized === void 0 || (_theme$customized = _theme$customized.radius) === null || _theme$customized === void 0 ? void 0 : _theme$customized.cards) !== null && _theme$customized$rad !== void 0 ? _theme$customized$rad : '17px';
}, layout, function (_ref3) {
  var breakpoint = _ref3.breakpoint;
  return breakpoint;
});
var Title = styled.span.withConfig({
  displayName: "category-tile__Title",
  componentId: "sc-134v6e-1"
})(["color:#242526;font-weight:bold;font-size:16px;margin:0;display:flex;@media screen and (min-width:", "px){font-size:20px;}"], function (_ref4) {
  var breakpoint = _ref4.breakpoint;
  return breakpoint;
});
var CardHeader = styled.div.withConfig({
  displayName: "category-tile__CardHeader",
  componentId: "sc-134v6e-2"
})(["width:100%;"]);
var Image = styled(Imgix).withConfig({
  displayName: "category-tile__Image",
  componentId: "sc-134v6e-3"
})(["border-radius:3px;object-fit:contain;width:100%;"]);
var ImageContainer = styled.div.withConfig({
  displayName: "category-tile__ImageContainer",
  componentId: "sc-134v6e-4"
})(["overflow:hidden;margin-top:auto;height:100%;width:100%;display:flex;justify-content:center;position:absolute;bottom:0;padding:38.3% 12.6% 9.4%;"]);